<mat-expansion-panel
  *ngIf="logTypes?.values?.length > 0; else elseBlockTypesNoData"
>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <span class="logtype"
        ><label [class]="getTypeClass(logTypes.labelType)">{{
          logTypes.labelType
        }}</label></span
      >
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ngx-json-viewer
    [json]="logTypes.values"
    [expanded]="true"
    [depth]="1"
  ></ngx-json-viewer>
</mat-expansion-panel>
<ng-template #elseBlockTypesNoData>
  <mat-expansion-panel disabled class="no-content">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <span class="logtype"
          ><label [class]="getTypeClass(logTypes.labelType)">{{
            logTypes.labelType
          }}</label></span
        >
      </mat-panel-title>
      <mat-panel-description
        ><label class="text-danger">No data</label></mat-panel-description
      >
    </mat-expansion-panel-header>
  </mat-expansion-panel>
</ng-template>
